import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import * as CandidateService from "@app/services/CandidateService";
import {toast} from "react-toastify";
import {checkExistsCommonFieldValues} from "@app/utils/CandidateUtils";
import {showMessage} from "@app/constants/Messages";

const JobSendRequestNoteContent = (props) => {
    const [noteList, setNoteList] = useState([]);
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {notes, onChange} = props

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(() => {
        setNoteList([...notes])
    }, [notes])

    const onChangeNoteInput = (event, index) => {
        console.log('onChangeNoteInput');
        noteList[index][event.target.name] = event.target.value;
        setNoteList([...noteList]);
        onChange(noteList)
    };

    return (
        <>
            <div className='card-body table-responsive p-0 w-100'>

                <table
                    className='table table-hover table-bordered text-nowrap'
                >
                    <thead>
                    <tr>
                        <th>STT</th>
                        <th>Note</th>
                        <th>User NL</th>
                        <th>Time</th>
                    </tr>
                    </thead>
                    <tbody>
                    {noteList && noteList.length > 0 && noteList.map((item, index) => (
                        <tr key={`job_send_request_note_row_${index}`}>
                            <td>{index + 1}</td>
                            <td>
                                <textarea className='form-control'
                                          value={item.notes ? item.notes : ''}
                                          name={'notes'}
                                          onChange={event => onChangeNoteInput(event, index)}/>
                            </td>
                            <td>{item.username}</td>
                            <td>{item.created_date_time}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default JobSendRequestNoteContent;
